import { UnitSelectorService } from '@addins/core/unit-activity';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActionSheetButton } from '@ionic/angular';
import { Crew } from '@models/imported/SagaSchema/Crew';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services/modal/modal.service';
import { ToastColor, ToastService } from '@services/toast/toast.service';
import { AddinExecute, Execute, ISetupDeviceResponse, MyEquipmentService, MyEquipmentState } from '@techwan/ionic-core';
import { lastValueFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

interface IUnitSetupResponse extends ISetupDeviceResponse {
  crew?: Crew;
}

@AddinExecute({
  name: 'CrewUnitCreationSetup'
})
@Injectable({
  providedIn: 'root'
})
export class UnitCreationSetupService extends Execute {
  private unitCreationButton: ActionSheetButton = null;
  private isLoading: boolean = false;

  constructor(
    private myEquipmentService: MyEquipmentService,
    private unitSelector: UnitSelectorService,
    private translate: TranslateService,
    private modal: ModalService,
    private http: HttpClient,
    private toast: ToastService
  ) {
    super();
  }

  execute() {
    this.myEquipmentService.stateChanged.pipe(filter(state => state === MyEquipmentState.ready)).subscribe(() => this.onEquipmentReady());
  }

  private onEquipmentReady() {
    let unit;
    this.myEquipmentService.myUnit.subscribe(u => (unit = u)).unsubscribe();

    if (unit === null) {
      const lastSetup: IUnitSetupResponse = this.myEquipmentService.lastSetup;
      if (lastSetup.crew) {
        if (!this.unitCreationButton) {
          this.unitCreationButton = this.unitSelector.createButton('Mobile.ActivateCrew', () => this.createUnit());
        }
        this.unitSelector.addUnitCreationButton(this.unitCreationButton);
        this.unitCreationButton.text = this.translate.instant('Mobile.ActivateCrew', { crewName: lastSetup.crew.Name });
      } else if (this.unitCreationButton) {
        this.unitSelector.removeUnitCreationButton(this.unitCreationButton);
        this.unitCreationButton = null;
      }
    } else if (this.isLoading) {
      this.dismissLoading();
    }
  }

  private createUnit() {
    this.modal
      .presentLoading()
      .then(() => {
        this.isLoading = true;
        lastValueFrom(this.http.post<boolean>('api/UnitActivity/CreateUnitActivityCrew', {})).then(isCreated =>
          isCreated ? isCreated : this.handleCreateUnitError()
        );
      })
      .catch(error => console.log(error));
  }

  private handleCreateUnitError() {
    this.dismissLoading().then(() => this.toast.show('Mobile.ErrorCreatingCrew', ToastColor.Error));
  }

  private dismissLoading(): Promise<any> {
    this.isLoading = false;
    return this.modal.dismissLoading();
  }
}
